import React from "react";
import { Link } from "react-router-dom";
import { COLORS } from "../constants/colors";
import "./Footer.css";

function Footer() {
  return (
    <footer className="footer">
      <div className="footer-content">
        {/* App Info */}
        <div className="footer-section">
          <h3 style={{ color: COLORS.primary }}>BudgetMate</h3>
          <p>
            Smart budget and expense tracking app designed to help you manage
            your money with clarity and confidence.
          </p>
        </div>

        {/* Navigation */}
        <div className="footer-section">
          <h4>Quick Links</h4>
          <ul>
            <li><Link to="/">Home</Link></li>
            <li><Link to="/about">About</Link></li>
            <li><Link to="/privacy">Privacy Policy</Link></li>
            <li><Link to="/terms">Terms & Conditions</Link></li>
          </ul>
        </div>

        {/* Contact */}
        <div className="footer-section">
          <h4>Support</h4>
          <p>
            Email:
            <br />
            <a href="mailto:budgetmate1.app@zohomail.in">
              budgetmate1.app@zohomail.in
            </a>
          </p>
        </div>
      </div>

      <div className="footer-bottom">
        © {new Date().getFullYear()} BudgetMate. All rights reserved.
      </div>
    </footer>
  );
}

export default Footer;
